import { Injectable } from '@angular/core';
import { Sort } from '../types/sort';
import { sort } from '../functions/sort.function';

@Injectable()
export class SortService {
  sort<T extends object>(values: T[], config: Sort<T>| null | undefined): T[] {
    return sort(values, config)
  }
}
